import type { Dict } from './en';

export const fr: Dict = {
  appTagline: 'Suivi de vols en direct, libre et ouvert',
  search: 'Rechercher un vol, une immatriculation, un hex ou un aéroport',
  searchNoResults: 'Rien trouvé à proximité ni sur le réseau.',
  searchUpstream: 'Recherche sur le réseau…',
  filters: 'Filtres',
  layers: 'Carte',
  settings: 'Réglages',
  about: 'À propos et données',
  close: 'Fermer',
  aircraft: 'Avions',
  inView: 'visibles',
  ground: 'Au sol',
  altitude: 'Altitude',
  geoAltitude: 'Altitude GPS',
  speed: 'Vitesse sol',
  vs: 'Vitesse verticale',
  track: 'Route vraie',
  squawk: 'Squawk',
  registration: 'Immatriculation',
  type: 'Type',
  category: 'Catégorie',
  hex: 'ICAO 24 bits',
  source: 'Source de position',
  positionAge: 'Âge de la position',
  provider: 'Fournisseur de données',
  route: 'Itinéraire',
  routeUnknown: 'Aucun itinéraire connu pour cet indicatif.',
  routeImplausible: 'Un itinéraire est connu pour cet indicatif, mais il ne correspond pas à la position actuelle de l’avion ; il est donc masqué.',
  routeNote: 'Itinéraire habituel de cet indicatif (données communautaires). Pas un horaire en direct.',
  follow: 'Suivre',
  unfollow: 'Ne plus suivre',
  share: 'Copier le lien',
  copied: 'Lien copié',
  trail: 'La trace montre les positions reçues depuis le début du suivi.',
  emergency: 'Urgence',
  military: 'Militaire',
  noCallsign: 'Sans indicatif',
  zoomIn: 'Zoomez pour charger les avions de toute la zone. Seul le centre est affiché.',
  stale: 'Données en direct retardées : le réseau communautaire limite le débit ou est indisponible. Dernières positions connues affichées.',
  offline: 'Vous êtes hors ligne. Les positions reprendront au retour de la connexion.',
  loading: 'Chargement des avions en direct…',
  errorData: 'Impossible de joindre l’API Skywake.',
  apiNotConfigured: 'Aucune API de données en direct n’est configurée pour cette version ; aucun avion ne peut être affiché.',
  retry: 'Réessayer',
  dataAge: 'Âge des données',
  providerStatus: 'État du fournisseur',
  ok: 'OK',
  degraded: 'Dégradé',
  theme: 'Thème',
  themeAuto: 'Système',
  themeLight: 'Clair',
  themeDark: 'Sombre',
  units: 'Unités',
  language: 'Langue',
  labels: 'Étiquettes d’indicatif',
  airports: 'Aéroports',
  trails: 'Trace de l’avion sélectionné',
  colorBy: 'Colorer les avions selon',
  colorAlt: 'Altitude',
  colorSource: 'Source de position',
  altMin: 'Altitude min. (ft)',
  altMax: 'Altitude max. (ft)',
  speedMin: 'Vitesse min. (kt)',
  speedMax: 'Vitesse max. (kt)',
  callsignPrefixes: 'Préfixes de compagnie / d’indicatif',
  callsignPrefixesHint: 'Séparés par des virgules, ex. AFR, EZY, RYR',
  types: 'Types d’avion',
  typesHint: 'Codes OACI, * comme joker, ex. A32*, B738',
  hideGround: 'Masquer les avions au sol',
  onlyEmergency: 'Urgences uniquement (7500/7600/7700)',
  onlyMilitary: 'Militaires uniquement',
  sources: 'Sources de position',
  presets: 'Préréglages enregistrés',
  presetName: 'Nom du préréglage',
  savePreset: 'Enregistrer les filtres actuels',
  apply: 'Appliquer',
  delete: 'Supprimer',
  clearFilters: 'Effacer les filtres',
  filtered: 'filtrés',
  airport: 'Aéroport',
  elevation: 'Altitude du terrain',
  nearbyTraffic: 'Trafic dans un rayon de 30 km',
  noNearby: 'Aucun avion suivi près de cet aéroport pour le moment.',
  viewOnOurAirports: 'Voir sur OurAirports',
  bookmarks: 'Favoris',
  bookmarkView: 'Ajouter cette vue aux favoris',
  watchlist: 'Surveiller',
  watching: 'Surveillé',
  alerts: 'Alertes',
  alertsEmergency: 'M’avertir des squawks d’urgence visibles',
  alertsWatch: 'M’avertir quand un avion surveillé apparaît',
  alertsPermissionDenied: 'Les notifications sont bloquées par votre navigateur. Les alertes s’afficheront seulement dans l’application.',
  emergencyAlert: 'Squawk d’urgence',
  watchAlert: 'Avion surveillé repéré',
  adsb: 'ADS-B',
  mlat: 'MLAT',
  tisb: 'TIS-B',
  adsr: 'ADS-R',
  modes: 'Mode S',
  other: 'Autre',
  attribution: 'Données avions : contributeurs ADSB.lol (ODbL 1.0). Itinéraires : VRS standing data (CC0). Aéroports : OurAirports (domaine public). Photos : photographes de Planespotters.net (crédités sur chaque photo). Météo : NOAA Aviation Weather Center (domaine public).',
  aboutBody:
    'Skywake est un logiciel libre et open source. Les positions proviennent de récepteurs ADS-B bénévoles agrégés par ADSB.lol ; la couverture dépend des lieux où des bénévoles installent des récepteurs. Pas de compte, pas de publicité, pas de cookies de suivi. Vos réglages restent sur cet appareil.',
  limitations: 'Limites connues',
  limitationsList:
    'Pas encore d’historique ni de relecture : Skywake n’affiche que ce qu’il a reçu depuis son ouverture.|Les itinéraires viennent d’une base communautaire d’indicatifs et peuvent être faux ou obsolètes.|La couverture est faible au-dessus des océans et dans les régions avec peu de récepteurs.|Les avions dont les propriétaires ont demandé la confidentialité (ex. LADD/PIA) peuvent être masqués ou anonymisés.',
  sourceCode: 'Code source',
  feedData: 'Installer un récepteur et alimenter ADSB.lol',
  version: 'Version',
  webglMissing: 'Votre navigateur ne peut pas afficher la carte en direct (WebGL2 indisponible).',
  selectedOutOfCoverage: 'Cet avion n’est plus reçu.',
  emergencies: 'Urgences',
  compare: 'Comparer',
  list: 'Liste',
  sortBy: 'Trier par',
  callsign: 'Indicatif',
  locate: 'Ma position',
  photoAlt: 'Photo de l’avion {reg}',
  weather: 'Météo (METAR)',
  weatherUnavailable: 'La météo est indisponible pour le moment.',
  weatherNone: 'Cet aéroport ne publie pas de METAR.',
  weatherSource: 'NOAA Aviation Weather Center. Ne pas utiliser pour la préparation des vols.',
  wind: 'Vent',
  calm: 'Calme',
  variable: 'Variable',
  gusts: 'rafales',
  visibility: 'Visibilité',
  temperature: 'Temp. / point de rosée',
  clouds: 'Nuages',
  observed: 'Âge du message',
  legFlown: 'parcourus',
  legToGo: 'restants',
  legEta: 'Arrivée',
  legNote: 'Estimation orthodromique d’après l’itinéraire habituel et la vitesse actuelle.',
};
